import { useMediaQuery } from "../../hooks/useMediaQuery";

const TransferNewsClearFilters = ({
  hasActiveFilters,
  filters,
  positions,
  getSelectedCountryName,
  getSelectedDivisionCountryName,
  getSelectedCompetitionName,
  handleClearFilter,
  handleClearAllFilters,
  isLoadingTransfers,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  
  if (!hasActiveFilters) return null;

  return (
    <div className="px-4 sm:px-6 lg:px-12 pb-4">
      <div className="flex flex-wrap gap-2 items-center justify-between">
        {/* Individual Clear Buttons - Desktop */}
        <div className="hidden sm:flex flex-wrap gap-2 items-center">
          {filters.country && (
            <button
              onClick={() => handleClearFilter("country")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Player Nationality: {getSelectedCountryName()}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.divisionCountry && (
            <button
              onClick={() => handleClearFilter("divisionCountry")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Division Country: {getSelectedDivisionCountryName()}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.competition_id && (
            <button
              onClick={() => handleClearFilter("competition_id")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Competition: {getSelectedCompetitionName()}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.position && (
            <button
              onClick={() => handleClearFilter("position")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Position:{" "}
              {positions.find((p) => p.id === filters.position)?.name ||
                filters.position}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.type && (
            <button
              onClick={() => handleClearFilter("type")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Type: {filters.type}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.date_from && (
            <button
              onClick={() => handleClearFilter("date_from")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              From: {filters.date_from}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
          {filters.date_to && (
            <button
              onClick={() => handleClearFilter("date_to")}
              className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              To: {filters.date_to}
              <svg
                className="w-3 h-3 ml-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
        </div>

        {/* Clear All Button - Desktop: Right side, Mobile: Center below */}
        <div className="hidden sm:block">
          <button
            onClick={handleClearAllFilters}
            className="text-sm text-blue-600 hover:text-blue-800 font-medium px-3 py-1 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
            disabled={isLoadingTransfers}
          >
            Clear All
          </button>
        </div>
      </div>

      {/* Mobile: Clear All button below */}
      <div className="sm:hidden flex justify-center mt-2">
        <button
          onClick={handleClearAllFilters}
          className="text-xs text-blue-600 hover:text-blue-800 font-medium px-3 py-1.5 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors max-w-[200px] w-full"
          disabled={isLoadingTransfers}
        >
          Clear All Filters
        </button>
      </div>
    </div>
  );
};

export default TransferNewsClearFilters;
